import $ from "jquery";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AddressMap from "./components/AddressMap.vue";
import AddressItemProfile from "./components/AddressItemProfile.vue";

const Address = addressList => {
    Vue.use(VueGoogleMaps, {
        load: {
            key: "AIzaSyBtZ68jL6KzuY4WIzg2Bk2z9TzUb6qdZvs",
            libraries: "places"
        }
    });

    return new Vue({
        el: "#address",
        data: {
            address: {
                list: addressList,
                countries: window.PlUs.countries
            },
            strings: window.PlUs.strings,
            paymentaddress: null,
            loading: true,
            disableRemove: false,
            disableCreate: false,
            showMapDiv: false,
            idAddressChange: null,
            newAddress: {
                name: "",
                surname: "",
                company_name: "",
                address: "",
                zip_code: "",
                district: "",
                city: "",
                country: "",
                telephone: "",
                primary: false,
                formatted_address: ""
            }
        },
        components: {
            "address-map": AddressMap,
            "address-item": AddressItemProfile
        },
        methods: {
            /**
             * Setta come primario l'indirizzo e lo aggiorna tramite le API
             * @param {integer} id
             */
            setPrimary(id) {
                const address = Object.assign(
                    {},
                    this.address.list.find(x => x.id == id)
                );
                address.primary = true;
                this.changeAddress(id, address);
            },
            /**
             * Pulisce di dati del nuovo indirizzo
             */
            resetNewAddress() {
                this.newAddress = {
                    name: "",
                    surname: "",
                    company_name: "",
                    address: "",
                    zip_code: "",
                    district: "",
                    city: "",
                    country: "",
                    telephone: "",
                    primary: false,
                    formatted_address: ""
                };
            },
            /**
             * Controlla il numero di indirizzi e disattiva i bottoni rimuovi e crea
             * - rimuovi viene mostrato solo se si hanno più di due indirizzi
             * - crea viene nascosto se si sono raggiunti i 5 indirizzi
             */
            check() {
                this.disableRemove = this.address.list.length == 1;
                this.disableCreate = this.address.list.length > 4;
            },
            /**
             * Mostra la mappa e l'autocomplete di google
             */
            showMap() {
                this.showMapDiv = true;
                $("#change-address").modal("show");
            },
            /**
             * Nasconde la mappa
             */
            hideMap() {
                this.showMapDiv = false;
                this.resetNewAddress();
                $("#change-address").modal("hide");
            },
            /**
             * Resetta i dati per inserire un nuovo indirizzo e mostra la mappa
             */
            showNewAddress() {
                this.idAddressChange = null;
                this.resetNewAddress();
                this.showMap();
            },
            /**
             * Valuta se creare un nuovo indirizzo o modificarne uno esistente
             */
            checkAddress() {
                if (this.idAddressChange == null) {
                    // creo un nuovo indirizzo
                    this.createAddress(this.newAddress);
                } else {
                    // modifico un indirizzo
                    this.changeAddress(this.idAddressChange, this.newAddress);
                }
            },
            /**
             * Crea un nuovo indirizzo
             * @param {Object} address
             */
            createAddress(address) {
                this.loading = true;
                window.axios
                    .post(window.PlUs.api.address, address)
                    .then(response => {
                        this.address.list = response.data.data.address;
                        this.hideMap();
                        this.loading = false;
                    })
                    .catch(function(error) {
                        console.error(error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: error
                        });
                        this.loading = false;
                    });
            },
            /**
             * Passando l'id di un indirizzo mostra la mappa la inizializza
             * con i dati dell'indirizzo richiesto
             * @param {integer} id
             */
            loadAddress(id) {
                this.idAddressChange = id;
                const foundAddress = this.address.list.find(x => x.id == id);

                // Debug: mostra cosa viene restituito dal database
                console.log("Found address from DB:", foundAddress);
                console.log("Company name:", foundAddress.company_name);

                this.newAddress = Object.assign({}, foundAddress);

                // Assicurati che company_name sia sempre presente e non null
                if (!this.newAddress.company_name) {
                    this.newAddress.company_name = "";
                    console.log(
                        "Company name was empty, initialized to empty string"
                    );
                }

                this.newAddress.formatted_address = [
                    this.newAddress.address,
                    this.newAddress.city,
                    this.newAddress.zip_code,
                    this.newAddress.district
                ].join(", ");
                this.showMap();
            },
            /**
             * Modifica i dati di un indirizzo tramite le API
             * @param {integer} id
             * @param {Object} address
             */
            changeAddress(id, address) {
                this.loading = true;
                window.axios
                    .put(window.PlUs.api.address + "/" + id, address)
                    .then(response => {
                        this.address.list = response.data.data.address;
                        this.hideMap();
                        this.loading = false;
                    })
                    .catch(error => {
                        console.error(error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: error
                        });
                        this.loading = false;
                    });
            },
            /**
             * Rimuove un indirizzo tramite le API
             * @param {integer} id
             */
            deleteAddress(id) {
                this.loading = true;
                window.axios
                    .delete(window.PlUs.api.address + "/" + id)
                    .then(response => {
                        this.address.list = response.data.data.address;
                        this.hideMap();
                        this.loading = false;
                    })
                    .catch(error => {
                        console.error(error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: error
                        });
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.check();
            this.loading = false;
            const _this = this;
            $("#change-address").on("hide.bs.modal", function(e) {
                _this.showMapDiv = false;
            });
        }
    });
};
export default Address;
